const generateUid = () => {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
};
// Checks if cart is empty
const isCartEmpty = () => {
  return dataLayer[0].shoptet.cart.length === 0;
};
// Sets and gets custom cut items from local storage
const setItems = (items) => {
  localStorage.setItem("vypocet", JSON.stringify(items));
};
const getItems = () => {
  return JSON.parse(localStorage.getItem("vypocet") || "[]");
};
// Removes custom cut item from local storage
const removeItem = (items, uid = null, itemId = null) => {
  if (uid) {
    items.splice(
      items.findIndex((item) => item.uid === uid),
      1,
    );
  } else if (itemId) {
    items.splice(
      items.findIndex((item) => item.itemId === itemId),
      1,
    );
  }
  return items;
};
// Cleans up local storage from items that are not in cart
const dataCleanup = () => {
  if (isCartEmpty()) {
    localStorage.removeItem("vypocet");
    return;
  } else {
    const items = getItems();
    const cartItems = dataLayer[0].shoptet.cart;

    const itemsNew = items.filter((item) => {
      const itemFound = cartItems.find(
        (cartItem) => cartItem.priceId == item.productData.priceId,
      );
      console.log(itemFound);
      return itemFound;
    });
    if (itemsNew.length === 0) {
      localStorage.removeItem("vypocet");
    } else if (items !== itemsNew) setItems(itemsNew);
  }
};
// Sets single custom cut item to local storage
const setSingleItem = (values, productData) => {
  const item = {
    uid: generateUid(),
    values: values,
    productData: productData,
  };

  const items = getItems();
  items.push(item);
  setItems(items);

  return item;
};

// Gets product data from detail page
const getProductDataDetail = () => {
  const productId = document.querySelector(
      '#product-detail-form input[name="productId"]',
    ).value,
    priceId = document.querySelector(
      '#product-detail-form input[name="priceId"]',
    ).value,
    productGuid = dataLayer[0].shoptet.product.guid,
    sku = dataLayer[0].shoptet.product.code,
    name = document.querySelector('.p-detail meta[itemprop="name"]').content;

  return {
    productId,
    priceId,
    productGuid,
    sku,
    name,
  };
};
// Gets product data from cart widget
const getProductDataCartWidget = (row) => {
  const cartItemId = row.querySelector('input[name="itemId"]').value,
    priceId = row.querySelector('input[name="priceId"]').value,
    productGuid = row.getAttribute("data-micro-identifier"),
    sku = row.getAttribute("data-micro-sku");

  return {
    cartItemId,
    priceId,
    productGuid,
    sku,
  };
};
// Gets product data from cart table
const getProductDataFromCartTable = (row) => {
  const cartItemId = row.querySelector('input[name="itemId"]').value,
    priceId = row.querySelector('input[name="priceId"]').value,
    productGuid = row.getAttribute("data-micro-identifier"),
    sku = row.getAttribute("data-micro-sku");

  return {
    cartItemId,
    priceId,
    productGuid,
    sku,
  };
};
// Gets product data from cart summary
const getProductDataFromCartSummary = (row) => {
  const productGuid = row.getAttribute("data-micro-identifier"),
    sku = row.getAttribute("data-micro-sku");

  return {
    productGuid,
    sku,
  };
};

// Gets custom cut data from product detail page
const getValues = () => {
  const amountInput = document.querySelector(
      "#product-detail-form input.amount",
    ),
    pcsQty = document.querySelector(".vypocet");
  summary = (parseFloat(pcsQty.value) * parseFloat(amountInput.value)).toFixed(
    3,
  );

  return {
    amount: amountInput ? amountInput.value : null,
    pcsQty: pcsQty ? pcsQty.value : null,
    summary: summary ? summary : null,
  };
};

// Locks quantity input
const lockCartRowQuantity = (row) => {
  if (!document.body.classList.contains("ordering-process")) return;
  const quantity = row.querySelector(".quantity");
  const label = quantity.querySelector("label");
  const labelMeasure = document.createElement("span");
  labelMeasure.textContent = " m";
  quantity.classList.add("readonly");
  label.appendChild(labelMeasure);
  quantity.querySelector(".increase").classList.add("hidden");
  quantity.querySelector(".decrease").classList.add("hidden");
  quantity.querySelector("input").setAttribute("readonly", true);
  quantity.setAttribute("title", "Množství nelze upravit");
};
// Locks quantity input in cart widget
const lockCartWidgetQuantity = () => {
  const cartWidget = document.querySelectorAll(".cart-widget-product");
  cartWidget.forEach((row) => {
    const rowProductInfo = getProductDataCartWidget(row);

    lockCartRowQuantity(rowProductInfo);
  });
};
document.addEventListener("DOMContentLoaded", () => {
  const cartData = dataLayer[0].shoptet.cart;
  document.querySelectorAll(".cart-table tr.removeable").forEach((row) => {
    const priceIdInput = row.querySelector('input[name="priceId"]');
    if (!priceIdInput) {
      console.warn("Chybí input s name='priceId' v řádku:", row);
      return;
    }
    const priceId = priceIdInput.value;

    const cartItem = cartData.find((c) => c.priceId == priceId);
    if (cartItem) {
      const input = row.querySelector('input[name="amount"]');
      if (input) input.value = cartItem.amount || cartItem.quantity;
    }
  });
});

// Creates custom cut row in cart table
const createCartTableRow = (item) => {
  const row = document.createElement("tr");
  row.classList.add("removeable", "product-add");
  row.setAttribute("linked-sku", item.productData.sku);
  row.innerHTML = `
			<td class="cart-p-image"></td>
			<td class="p-name">
				<span style="display: block">Množství: ${item.values.amount.toLocaleString("cs-CZ").replace(".", ",")} m</span>
				<span style="display: block">Počet kusů: ${item.values.pcsQty.toLocaleString("cs-CZ").replace(".", ",")} ks</span>
			</td>
			<td class="p-availability p-cell"></td>
			<td class="p-quantity p-cell">
				<span>Celkové množství: ${item.values.summary.toLocaleString("cs-CZ").replace(".", ",")} m</span>
			</td>
			<td class="p-price"></td>
			<td class="p-total">
				<span class="price-final"></span>
				<button class="remove-item" data-uid="${item.uid}">
					<span class="sr-only">Odebrat</span>
				</button>
			</td>
		`;
  const removeButton = row.querySelector(".remove-item");
  removeButton.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();

    const items = getItems();
    const uid = removeButton.getAttribute("data-uid");
    const newItems = removeItem(items, uid);
    setItems(newItems);

    // Odstraní pouze tento konkrétní řádek
    row.remove();

    // Odečte množství pouze v hlavním produktu, ne v ostatních
    const linkedRow = document.querySelector(
      `.cart-table tr[data-micro-sku="${item.productData.sku}"]`,
    );
    if (!linkedRow) return;

    const linkedRowQuantity = linkedRow.querySelector(".quantity input");
    console.log("kus", item.values.summary);
    console.log("linkedRowQuantity", linkedRowQuantity.value);
    linkedRowQuantity.value =
      parseFloat(linkedRowQuantity.value) - parseFloat(item.values.summary);
    const qtyForm = linkedRow.querySelector(".quantity-form");
    if (qtyForm) {
      qtyForm.dispatchEvent(new Event("submit", { bubbles: true }));
    }
    // Pokud nové množství je <= 0, odebere hlavní produkt
    if (parseFloat(linkedRowQuantity.value) <= 0) {
      const form = linkedRow.querySelector("form.inline");
      if (form)
        setTimeout(() => {
          form.submit();
        }, 100);
    }
  });

  return row;
};
// Creates custom cut row in cart summary
const createCartSummaryRow = (item) => {
  const row = document.createElement("div");
  row.classList.add("cart-item");
  row.style.paddingLeft = "20px";
  row.innerHTML = `
			<div class="cart-item-name">
				<div class="main-link">
					<div>Množství: ${item.values.amount.toLocaleString("cs-CZ").replace(".", ",")} m</div>
					<div>Počet kusů: ${item.values.pcsQty.toLocaleString("cs-CZ").replace(".", ",")} ks</div>
				</div>
			</div>
			<div class="cart-item-amount">
				<div>${item.values.summary.toLocaleString("cs-CZ").replace(".", ",")} m</div>
			</div>
			<div class="cart-item-price">
			</div>
		`;
  return row;
};
const addMeasureToQty = () => {
  const flagMetraz = document.querySelector(".p-info-wrapper .flag-metraz");
  if (!flagMetraz) return;
  const measure = document.querySelector(".pr-list-unit");
  const addToCartWrapper = document.querySelector(".add-to-cart-wrapper");
  if (!measure) return;

  const quantity = document.querySelector(".add-to-cart-wrapper .quantity");
  if (!quantity) return;

  const qtyPlusMeasure = document.createElement("div");
  qtyPlusMeasure.classList.add("qty-plus-measure");
  const qtySpan = document.createElement("span");
  qtySpan.classList.add("how-many");
  qtySpan.style.order = "-2";

  qtySpan.innerHTML =
    "<input name='quantity' type='number' value='1' class='form-control vypocet' /><label>ks</label>";

  qtyPlusMeasure.appendChild(quantity);
  qtyPlusMeasure.prepend(qtySpan);
  addToCartWrapper.prepend(qtyPlusMeasure);
  return;
};

if (dataLayer[0].shoptet.pageType === "productDetail") {
  document.addEventListener("DOMContentLoaded", addMeasureToQty);

  let listenerAdded = false;

  setTimeout(() => {
    const hasVypocet = document.querySelector(".how-many .vypocet");
    if (hasVypocet) {
      const form = document.querySelector(
        ".p-detail-inner #product-detail-form",
      );
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopPropagation();

        let productData = getProductDataDetail();
        let values = getValues();
        shoptet.cartShared.addToCart({
          priceId: productData.priceId,
          amount: values.summary,
        });
        setSingleItem(values, productData);
        hasVypocet.value = "1";
      });

      listenerAdded = true;
    }
  }, 250);
}
document.addEventListener("ShoptetCartUpdated", () => {
  dataCleanup();
  lockCartWidgetQuantity();
});
document.addEventListener("ShoptetDOMCartContentLoaded", () => {
  lockCartWidgetQuantity();
  if (!document.body.classList.contains("ordering-process")) return;
  window.location.reload();
});
if (dataLayer[0].shoptet.pageType === "cart") {
  const cartRows = document.querySelectorAll(".cart-table tr.removeable");
  const items = getItems();
  cartRows.forEach((row) => {
    const rowProductInfo = getProductDataFromCartTable(row);
    const customProductData = items.filter(
      (item) => item.productData.priceId === rowProductInfo.priceId,
    );

    if (customProductData.length > 0) {
      lockCartRowQuantity(row);
      customProductData.forEach((item) => {
        const newRow = createCartTableRow(item);
        row.parentElement.insertBefore(newRow, row.nextElementSibling);
      });
    }
  });
}
const cartItems = document.querySelector("#summary-box .cart-items");
if (cartItems) {
  const items = getItems();
  const cartRows = cartItems.querySelectorAll(".cart-item");
  cartRows.forEach((row) => {
    const productData = getProductDataFromCartSummary(row);
    const customProductData = items.filter(
      (item) => item.productData.sku === productData.sku,
    );
    if (customProductData.length > 0) {
      customProductData.forEach((itemRow) => {
        row.parentElement.insertBefore(
          createCartSummaryRow(itemRow),
          row.nextElementSibling,
        );
      });
    }
  });
}
const submitOrder = document.querySelector("#order-form:has(#submit-order)");
if (submitOrder) {
  submitOrder.addEventListener("submit", (e) => {
    // e.preventDefault()
    // e.stopPropagation()

    const addNote = submitOrder.querySelector("#add-note");
    if (addNote && !addNote.checked) addNote.checked = true;
    const noteWrapper = submitOrder.querySelector("#note");
    if (noteWrapper) noteWrapper.classList.add("visible");
    const remark = submitOrder.querySelector("#remark");

    let additionalRemark = "";
    if (remark.value != "") additionalRemark = "\n\n";
    additionalRemark += "Doplňující informace:\n";
    const items = getItems();
    if (items.length > 0 && remark) {
      items.forEach((item, index) => {
        additionalRemark += `Produkt: ${item.productData?.name} - ${item.productData.sku}\n Délka: ${item.values.amount.toLocaleString("cs-CZ").replace(".", ",")} m, Počet kusů: ${item.values.pcsQty.toLocaleString("cs-CZ").replace(".", ",")} ks, Celkem: ${item.values.summary.toLocaleString("cs-CZ").replace(".", ",")} m`;
        if (index < items.length - 1) additionalRemark += "\n\n";
      });
    }

    if (remark.value.trim().includes(additionalRemark.trim())) {
      remark.value = remark.value.replaceAll(additionalRemark.trim(), "");
      remark.value = remark.value.trim();
    }
    remark.value = remark.value + additionalRemark;
  });
}
if (dataLayer[0].shoptet.pageType === "thankYou") {
  localStorage.removeItem("vypocet");
}
